import { StyleSheet, View } from "react-native";

import {
  radii,
  useTheme,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

/** Thin completion bar built from plain views — no charting dependency. */
export function ProgressBar({
  value,
  tone = "primary",
  height = 6,
}: {
  /** 0..1 */
  value: number;
  tone?: "primary" | "danger" | "neutral";
  height?: number;
}) {
  const { colors } = useTheme();
  const stylesheet = useThemedStyles(makeStyles);
  const clamped = Math.max(0, Math.min(1, Number.isFinite(value) ? value : 0));
  const fillColor =
    tone === "danger"
      ? colors.danger
      : tone === "neutral"
        ? colors.borderStrong
        : colors.primary;

  return (
    <View
      accessibilityRole="progressbar"
      accessibilityValue={{ now: Math.round(clamped * 100), min: 0, max: 100 }}
      style={[stylesheet.track, { height, borderRadius: height }]}
    >
      <View
        style={[
          stylesheet.fill,
          {
            width: `${clamped * 100}%`,
            backgroundColor: fillColor,
            borderRadius: height,
          },
        ]}
      />
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    track: {
      width: "100%",
      overflow: "hidden",
      backgroundColor: colors.surface,
      borderRadius: radii.pill,
    },
    fill: { height: "100%", minWidth: 2 },
  });
